import { Box, Typography } from '@material-ui/core';
import * as React from 'react';
import { TimePickerFieldProps } from './model';
import { TimeTextField } from './TimeTextField';

export const TimePickerField = ({ value, handleChange, placeHolder }: TimePickerFieldProps) => {
  return (
    <React.Fragment>
      <TimeTextField value={value} onChange={handleChange} placeholder={placeHolder} />
    </React.Fragment>
  );
};
